import React from "react";
import { history } from "@umijs/max";
import { Avatar, Space, Dropdown, Button } from "antd";
import type { MenuProps } from "antd";
import { useRou } from "@/utils/rou";
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  BellOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { AvatarDropdown } from "@/components";
import { AvatarName } from "@/components";
import defaultSettings from "../../../config/defaultSettings";
import "./index.less";

interface HeaderProps {
  collapsed?: boolean;
  onCollapse?: (collapsed: boolean) => void;
  currentUser?: any;
}
const callRou = useRou();
const Header: React.FC<HeaderProps> = ({
  collapsed = false,
  onCollapse,
  currentUser,
}) => {
  // 处理logo点击事件
  const handleLogoClick = async () => {
    const routerObj: any = await callRou.getHome();
    if (routerObj) {
      history.push(routerObj.path);
    }
  };

  // 用户下拉菜单
  const userMenuItems: MenuProps["items"] = [
    // {
    //   key: 'profile',
    //   icon: <UserOutlined />,
    //   label: '个人中心',
    // },
    // {
    //   key: 'settings',
    //   icon: <SettingOutlined />,
    //   label: '个人设置',
    // },
    // {
    //   type: 'divider',
    // },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "退出登录",
    },
  ];

  const handleUserMenuClick: MenuProps["onClick"] = ({ key }) => {
    console.log(key,'key')
    if (key === "logout") { 
      callRou.logout();
    } else if (key === "profile") {
      // 跳转到个人中心
      history.push("/account/profile");
    } else if (key === "settings") {
      // 跳转到个人设置
      history.push("/account/settings");
    }
  };
  const firstLetter = (currentUser?.name || "unknown").split("")[0];
  return (
    <div className="custom-header">
      <div className="header-left">
        <div className="logo" onClick={handleLogoClick}>
          <img src={defaultSettings.logo} alt="logo" />
          {!collapsed && <span className="title">{defaultSettings.title}</span>}
        </div>
      </div>

      <div className="header-right">
        <Space size="middle" wrap>
          

          {/* 用户头像和下拉菜单 */}
          <Dropdown
            menu={{ items: userMenuItems, onClick: handleUserMenuClick }}
            placement="bottomRight"
            arrow
          >
            <div className="avatar-container">
               
                <span className="avatar-container-first-letter">{firstLetter}</span>
            </div>
          </Dropdown>
        </Space>
      </div>
    </div>
  );
};

export default Header;
